import React, { Component } from "react";

import Queries from "../../queries/queries2";
import SimpleSelect from "../../elements/CustomSelect/SimpleSelect";
import Spinner from "../../elements/Spinner/Spinner";
import { graphql } from "react-apollo";
import { injectIntl } from "react-intl";
import languages from "@cospired/i18n-iso-languages";

class LanguageSelect extends Component {
  constructor(props) {
    super(props);
    this.splitLocale = `${props.intl.locale.split("-")[0]}`;
    try {
      languages.registerLocale(
        require(`@cospired/i18n-iso-languages/langs/${this.splitLocale}.json`)
      );
    } catch (e) {
      this.splitLocale = "en";
      languages.registerLocale(
        require(`@cospired/i18n-iso-languages/langs/en.json`)
      );
    }
  }

  render() {
    if (this.props.getAllLanguages.loading) {
      return <Spinner size="lg" fullScreen />;
    }

    let options = [];
    options =
      this.props.getAllLanguages.languages &&
      this.props.getAllLanguages.languages.map(language => {
        return {
          label: languages.getName(language.code, this.splitLocale),
          value: language.id
        };
      });
    return (
      <SimpleSelect
        clearable={false}
        name="language"
        value={this.props.value}
        onSelected={this.props.onSelected}
        options={options}
      />
    );
  }
}

LanguageSelect = graphql(Queries.GET_ALL_LANGUAGES, {
  name: "getAllLanguages"
})(LanguageSelect);
export default injectIntl(LanguageSelect);
